import React, { useMemo } from 'react';
import StatCard from './StatCard';
import { cs2StatusView } from '../utils/cs2StatusView';

/**
 * Computes Ready / Cooldown / Banned / Attention tallies from the currently-loaded accounts.
 * The "Attention" bucket combines quarantined accounts and accounts in the login_error
 * state (≥ 3 consecutive failures but not yet quarantined) — both need operator action.
 */
export default function StatStrip({ accounts }) {
  const stats = useMemo(() => {
    const out = {
      ready: 0,
      cooldown: 0, cooldownMajor: 0, cooldownMinor: 0,
      banned: 0, vac: 0, game: 0,
      quarantined: 0, loginError: 0
    };
    for (const acc of accounts) {
      const lbs = acc.lastBanState || {};
      const isBanned = lbs.communityBanned || (lbs.numberOfVACBans || 0) > 0 || (lbs.numberOfGameBans || 0) > 0 || (lbs.economyBan && lbs.economyBan !== 'none');
      if (isBanned) {
        out.banned += 1;
        if ((lbs.numberOfVACBans || 0) > 0) out.vac += 1;
        if ((lbs.numberOfGameBans || 0) > 0) out.game += 1;
        continue;
      }
      const view = cs2StatusView(acc);
      if (view.kind === 'quarantined') { out.quarantined += 1; continue; }
      if (view.kind === 'login_error') { out.loginError += 1; continue; }
      if (view.kind === 'cooldown') {
        out.cooldown += 1;
        const level = acc.cs2State?.cooldownLevel;
        if (level === 'major' || level === 'permanent') out.cooldownMajor += 1; else out.cooldownMinor += 1;
        continue;
      }
      if (view.kind === 'ready') out.ready += 1;
    }
    return out;
  }, [accounts]);

  const attention = stats.quarantined + stats.loginError;

  return (
    <div className="grid grid-cols-4 gap-3 mb-4">
      <StatCard label="Ready"     value={stats.ready}    barColor="success" />
      <StatCard label="Cooldown"  value={stats.cooldown} barColor="warn"    sublabel={`${stats.cooldownMajor} major · ${stats.cooldownMinor} minor`} />
      <StatCard label="Banned"    value={stats.banned}   barColor="danger"  sublabel={`${stats.vac} VAC · ${stats.game} game`} />
      <StatCard
        label="Attention"
        value={attention}
        barColor={attention > 0 ? 'danger' : 'muted'}
        valueTone="muted"
        sublabel={`${stats.quarantined} quarantined · ${stats.loginError} login error${stats.loginError === 1 ? '' : 's'}`}
      />
    </div>
  );
}
